import styled from "styled-components";
import pokemons from "../../../assets/pokemons.jpg";
import CvTechIcons from "./CvTechIcons";
import CvDescription from "./CvDescription";

export default function Twitter() {
  return (
    <ProjectContainer>
      <ProjectDesc>
        <div>
          <h2>My portfolio</h2>
          <p>
            This portfolio leverages styled-components, a powerful library for
            React, allowing for seamless and maintainable CSS-in-JS styling.
          </p>
        </div>
        <div>
          <Features>Used technologies:</Features>
          <CvTechIcons />
        </div>
        <div>
          <Features>Features/Description:</Features>
          <CvDescription />
        </div>
      </ProjectDesc>
    </ProjectContainer>
  );
}

const ProjectDesc = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  & > div > h2 {
    color: rgba(104, 197, 117, 0.87);
    padding-bottom: 14px;
  }

  & > h2,
  div {
    margin-bottom: 30px;

    @media (max-width: 460px) {
      margin-bottom: 10px;
    }
  }
`;

const ProjectContainer = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  margin-top: 30px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  overflow: hidden;
  color: white;
  padding: 10px 20px;
  transition: all 0.1s ease;

  &:hover {
    background: rgba(36, 36, 41, 0.87);
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    justify-content: center;
  }
`;

const ProjectImageWrapper = styled.div`
  position: relative;
  width: 500px; /* Ustaw stałą szerokość kontenera */
  height: 400px;
  overflow: hidden;
  border-radius: 8px;

  &:hover img {
    transform: translateY(-50%);
  }
`;

const Overview = styled.div`
  display: flex;
  flex-direction: column;

  > h2 {
    margin-bottom: 10px;
  }

  @media (max-width: 1024px) {
    align-items: center;
    justify-content: center;
    r > h2 {
      justify-content: center;
    }
  }
  @media (max-width: 670px) {
    display: none;
  }
`;

const ProjectImage = styled.img`
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 4s ease-in-out;
`;

const Features = styled.div`
  color: rgba(104, 197, 117, 0.87);
  font-weight: bold;
  margin-bottom: 0 !important;
  padding: 0;
`;
